module.exports = __webpack_public_path__ + "static/media/20160915_143022.c6a3e831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20160915_143022.jpg
// module id = 453
// module chunks = 0